import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { formatPriceString } from 'site-modules/shared/utils/price-utils';

/**
 * Renders price change details
 * @param {string} icon
 * @param {string} price
 * @param {string} text
 */
function renderPriceChange(icon, text, price) {
  return (
    <li className="d-flex align-items-center">
      <i className={classNames('d-block list-pic pe-0_75', icon)} aria-hidden />
      <span className="fw-bold">{price}</span>&nbsp;{text}
    </li>
  );
}

export function InventoryPriceChange({ concealHistoryPrices = false, totalPriceChange = 0 }) {
  let isPriceDrop;
  let priceChange;
  if (totalPriceChange) {
    isPriceDrop = totalPriceChange < 0;
    priceChange = Math.abs(totalPriceChange);
  }
  const priceText = isPriceDrop ? 'drop' : 'increase';
  return (
    <Fragment>
      {concealHistoryPrices && renderPriceChange('icon-warning2', 'Price history not available in Texas')}
      {!!totalPriceChange &&
        !concealHistoryPrices &&
        renderPriceChange(
          'icon-stats-dots',
          `price ${priceChange === 0 ? 'change' : priceText}`,
          formatPriceString(priceChange)
        )}
      {!totalPriceChange && !concealHistoryPrices && renderPriceChange('icon-arrow-right8', 'No price change')}
    </Fragment>
  );
}
InventoryPriceChange.propTypes = {
  concealHistoryPrices: PropTypes.bool,
  totalPriceChange: PropTypes.number,
};
